<template>
  <div class="contents">
    <div class="layout">
      <!-- s::title-breadcrumbs -->
      <div class="page-top">
        <h2>서비스 소개 관리</h2>
<!--        <div class="breadcrumbs">-->
<!--          <span>컨텐츠 관리</span>-->
<!--          <span class="color-black">배너 관리</span>-->
<!--        </div>-->
      </div>
      <!-- e::title-breadcrumbs -->

      <div class="white-panel mt30">

        <div class="table-wrap">
          <div class="upload-guide">
            <p class="upload-guide__title">📌 이미지 업로드 가이드</p>
            <ul class="upload-guide__desc">
              <li>파일 형식은 <strong>PNG(.png)</strong>만 허용됩니다.</li>
              <li>업로드 시 아래 표에 맞춰 <strong>파일명을 정확히 설정</strong>해주세요.</li>
              <li>PC용은 <strong>PC 이미지 업로드</strong>, 모바일용은 <strong>MO 이미지 업로드</strong>에 업로드해주세요.</li>
              <li>수정된 항목의 이미지 파일만 선택하거나, 전체 이미지 파일(1.png ~ 10.png)을 모두 선택하여 [수정하기] 버튼을 눌러주세요.</li>
            </ul>

            <table class="upload-guide__table">
              <thead>
              <tr>
                <th>번호</th>
                <th>항목 이름</th>
                <th>파일명</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="section in sections" :key="section.id">
                <td>{{ section.id }}</td>
                <td>{{ section.label }}</td>
                <td><code>{{ section.id }}.png</code></td>
              </tr>
              </tbody>
            </table>
          </div>

          <table class="table-type2">
            <colgroup>
              <col style="width:200px;">
              <col>
            </colgroup>
            <tbody>
            <!-- PC 이미지 업로드 -->
            <tr>
              <th style="vertical-align: top;">PC 이미지 업로드</th>
              <td>
                <input type="file" id="pcFiles" multiple accept="image/png" @change="onFileSelect($event, 'pc')" />
                <ul>
                  <li v-for="file in previews.pc" :key="file.name">
                    {{ file.display }}
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <hr/>
              </td>
            </tr>
            <!-- 모바일 이미지 업로드 -->
            <tr>
              <th style="vertical-align: top;">MO 이미지 업로드</th>
              <td>
                <input type="file" id="moFiles" multiple accept="image/png" @change="onFileSelect($event, 'mo')" />
                <ul>
                  <li v-for="file in previews.mo" :key="file.name">
                    {{ file.display }}
                  </li>
                </ul>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="button-panel mt30">
        <div class="right">
          <button @click="saveItem" type="button" class="button navy-button">수정하기</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {apiClient} from '@/services/auth-header';

const API_URL = '/support'
const sections = [
  { id: 1, label: '플랫폼 소개' },
  { id: 2, label: '회원별 주요 서비스' },
  { id: 3, label: '플랫폼 한눈에 보기' },
  { id: 4, label: '회원 가입 및 승인' },
  { id: 5, label: '프로필 등록' },
  { id: 6, label: '아트워크 등록 및 관리' },
  { id: 7, label: '포트폴리오 제작' },
  { id: 8, label: '공모 지원하기' },
  { id: 9, label: 'Q&A' },
  { id: 10, label: 'CONTACT US' }
]


import { ref } from 'vue'

const pcFiles = ref([])
const moFiles = ref([])
const previews = ref({ pc: [], mo: [] })

const findSectionLabel = (filename) => {
  const id = parseInt(filename.replace('.png', ''), 10)
  const section = sections.find(s => s.id === id)
  return section ? `${section.id}. ${section.label}` : '❌ 잘못된 파일명'
}

const onFileSelect = (event, device) => {
  const files = Array.from(event.target.files).filter(f => f.type === 'image/png')

  if (device === 'pc') pcFiles.value = files
  else moFiles.value = files

  previews.value[device] = files.map(file => {
    const label = findSectionLabel(file.name)
    return {
      name: file.name,
      display: `${label} (${file.name})`
    }
  })
}

const saveItem = async () => {
  if (!pcFiles.value.length && !moFiles.value.length) {
    alert('업로드할 파일을 선택해주세요.')
    return
  }

  const formData = new FormData()
  pcFiles.value.forEach(file => formData.append('pcFiles', file))
  moFiles.value.forEach(file => formData.append('moFiles', file))

  try {

    await apiClient.put(API_URL + '/service-info/image-upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    alert('업로드 완료되었습니다.')

    window.location.reload();
  } catch (err) {
    console.error(err)
    alert('업로드 실패: ' + err.message)
  }
}

</script>

<style scoped>
.upload-guide {
  margin-bottom: 24px;
  padding: 16px;
  border: 1px solid #ccc;
  background: #f9f9f9;
  font-size: 14px;
  line-height: 1.6;
}

.upload-guide__title {
  font-weight: bold;
  margin-bottom: 8px;
}

.upload-guide__desc {
  list-style: disc;
  padding-left: 20px;
  margin-bottom: 12px;
}

.upload-guide__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.upload-guide__table th,
.upload-guide__table td {
  border: 1px solid #ccc;
  padding: 6px 10px;
  text-align: left;
}

.upload-guide__table th {
  background: #f0f0f0;
}

</style>